export default __webpack_public_path__ + "static/media/ukrainegot-screenshot-05.75ff3aca.png";